import React, {
    useContext, useMemo
} from 'react';
import htmlParser from 'html-react-parser';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgPaymentFooter.messages';

function SgPaymentFooter() {
    const translator = useContext(TranslatorContext);

    const monthlyDdiFooter = useMemo(() => {
        return (
            <>
                <div>
                    <h3>{translator(messages.DdiGuaranteeTitle)}</h3>
                    <ul>
                        <li>{translator(messages.DdiGuarantee0)}</li>
                        <li>{translator(messages.DdiGuarantee1)}</li>
                        <li>{htmlParser(translator(messages.DdiGuarantee2))}</li>
                        <li>{translator(messages.DdiGuarantee3)}</li>
                    </ul>
                </div>
                <div>
                    <div className="ddGuaranteeLogo" />
                </div>

            </>
        );
    }, []);

    return (

        <div className="sgPaymentDDFooter">
            {monthlyDdiFooter}
        </div>

    );
}
export default SgPaymentFooter;
